import { Title } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {FadeZoomInTop} from "../../animations/fade-zoom-in-top.decorator";
import { ClientService } from '../../services/client.service';
import { ConfigService } from "../../utils/config.service";
import { Subscription } from "rxjs/Rx";

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  styles: []
})
  //comment
export class AuthLayoutComponent implements OnInit {
  client: any = {
    clientSetting: {
      siteSetting: {
        loginPage: { loginMainContent: "", loginBottomContent:"", loginFooterContent:"",loginLogoUrl:""}
      }
    }
    };
  subDomain: string = '';
  loginLogoStyle: any = {};
  constructor(
    private route: ActivatedRoute,
    private router: Router,private titleService: Title,
    private clientService: ClientService,
    private configService: ConfigService) {
    
    this.subDomain = this.configService.getSubdomain();
    this.clientService.setClientBySubDomain(this.subDomain).then(async(data) => {
      this.client = await data;
      this.clientService.setClientProperties(this.client);
      try {
        if (this.client != null && this.client.clientSetting != null) {
          this.loginLogoStyle = JSON.parse(this.client.clientSetting!.siteSetting!.loginPage!.loginLogoStyle || {});
        }
      }
      catch (e) {
      }
    });

  }
      
  ngOnInit() {

   
  }

}
